import VueCookies from "vue-cookies";

export default {
  methods: {
    buildHeaders() {
      const headers = {};
      const token = VueCookies.get("deatoken");
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
      return headers;
    },
    async fetchChild(parentLogin, localChild, redirectLink) {
      fetch(`${this.$root.config.userSwitchURL}`, {
        method: "PATCH",
        withCredentials: true,
        headers: this.buildHeaders(),
        body: JSON.stringify({ child: localChild }),
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.setToken(data, this.user);
          const registerSwitch = parentLogin
            // eslint-disable-next-line no-template-curly-in-string
            .replace("${child}", localChild)
            // eslint-disable-next-line no-template-curly-in-string
            .replace("${url}", encodeURIComponent(redirectLink));
          document.location = registerSwitch;
        })
        .catch(() => {
          // console.log("error loading user", error);
        });
    },
    // FIXME: rivedere tutto quello quello che deriva / usa login.js
    setToken(data, parent) {
      const secure = document.location.protocol === "https:" && this.$root.config.useSecureCookie;
      if (data.token) {
        this.token = data.token;
        this.$cookies.set("deatoken", data.token, "0", "/", ".deascuola.it", secure, "Lax");
      } else {
        this.token = this.$cookies.get("deatoken");
      }
      if (parent) {
        this.parent_token = parent.token;
        this.$cookies.set("deatoken_parent", parent.token, "0", "/", ".deascuola.it", secure, "Lax");
      }
    },
  },
};
